// Full branch-management CRUD — POST/PUT/DELETE /branches are ENTERPRISE-only
// server-side (lendcord-core's BranchService.requireEnterprise, LEND-093).
// Deliberately a separate injectEndpoints call from
// features/onboarding/api/branches.api.ts (which only needs a read-only
// dropdown-shaped list) rather than widening that file — both share the same
// "Branch" tag on the one baseApi instance, so a create/update/delete here
// invalidates and refetches that dropdown too, for free.

import { baseApi } from "@/app/store/baseApi";
import type { Branch, BranchRequest } from "../setup.types";

export const branchesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listBranchesFull: builder.query<Branch[], void>({
      query: () => ({ url: "/branches", auth: true }),
      providesTags: (branches) =>
        branches
          ? [{ type: "Branch" as const, id: "LIST" }, ...branches.map((b) => ({ type: "Branch" as const, id: b.id }))]
          : [{ type: "Branch" as const, id: "LIST" }],
    }),
    createBranch: builder.mutation<Branch, BranchRequest>({
      query: (body) => ({ url: "/branches", method: "POST", body, auth: true }),
      invalidatesTags: [{ type: "Branch", id: "LIST" }],
    }),
    updateBranch: builder.mutation<Branch, { id: string; body: BranchRequest }>({
      query: ({ id, body }) => ({ url: `/branches/${id}`, method: "PUT", body, auth: true }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Branch", id: "LIST" },
        { type: "Branch", id },
      ],
    }),
    deleteBranch: builder.mutation<void, string>({
      query: (id) => ({ url: `/branches/${id}`, method: "DELETE", auth: true }),
      invalidatesTags: (result, error, id) => [
        { type: "Branch", id: "LIST" },
        { type: "Branch", id },
      ],
    }),
  }),
});

export const {
  useListBranchesFullQuery,
  useCreateBranchMutation,
  useUpdateBranchMutation,
  useDeleteBranchMutation,
} = branchesApi;
